import moment from "moment-timezone";

export const standardDateFormat = "MM/DD/YYYY HH:mm:ss";
export const UTCTimeZoneName = "Europe/Dublin";

export const formatInTimezone = (
  date: moment.MomentInput,
  timezone: string,
  dateFormat: string = standardDateFormat
): string => {
  return moment(date)
    .tz(timezone)
    .format(dateFormat !== "ISO8601" ? dateFormat : undefined);
};

export const getFormattedDateTimeWithTZ = (
  date: moment.MomentInput,
  timezone: string
): moment.MomentInput => {
  return moment.tz(date, timezone).format(standardDateFormat);
};

export const getDateTimeInUTCByZone = (
  date: moment.MomentInput,
  timezone: string
): moment.MomentInput => {
  // get zone object
  const zone = moment.tz.zone(timezone);
  // get offset in minutes
  const offsetInMinutes = zone?.utcOffset(
    new Date(date?.toString() || "").getTime()
  ); // offset changes for DST

  return moment(date)
    .add(offsetInMinutes, "minutes")
    .format(standardDateFormat);
};

export const getDateTimeInUTCByZoneWithoutFormat = (
  date: moment.MomentInput,
  timezone: string
): moment.MomentInput => {
  const utcDateTime = getDateTimeInUTCByZone(date, timezone);
  // eslint-disable-next-line no-underscore-dangle
  return moment.tz(utcDateTime, "GMT");
};

export const formatToUTC = (
  date: moment.MomentInput,
  timezone: string
): string => {
  return moment.tz(date, timezone).utc().format();
};

export const validDate = (date: string | undefined): boolean => {
  return date != null && moment(date, "YYYY-MM-DD", true).isValid();
};

export const validTime = (time: string | undefined): boolean => {
  return time != null && moment(time, "HH:mm:ss", true).isValid();
};

export const formatAMPM = (time: string): string => {
  const hours = parseInt(time.split(":")[0], 10);

  const ampm = hours >= 12 ? "PM" : "AM";

  return ampm;
};

export const convertToAmPM = (time: string, period: string): number => {
  let result = parseInt(time, 10);
  if (period === "PM" && parseInt(time, 10) < 12)
    result = parseInt(time, 10) + 12;
  if (period === "AM" && parseInt(time, 10) === 12)
    result = parseInt(time, 10) - 12;

  return result;
};
